import React, { useEffect, useRef, useState } from "react";
import { bidContigencyType, financeEmd, submitOffer } from "@/api/placeOffer";
import { ClosingOptionTextBuyer, ClosingOptionTextSeller } from "@/setting";
import DetailsForm from "./DetailsForm";
import { ClosingAgent, TitleInsuranceProvider } from "./formState";
import SaveClosingModal from "./SaveClosingModal";
import { MdError } from "react-icons/md";
import ReactHtmlParser from "react-html-parser";
import { spbpDescText } from "@/data/sellerPaysBuyersPays";
import { isValidSession } from "@/api/auth";
import { toast } from "react-toastify";
import { batch, useDispatch, useSelector } from "react-redux";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import LoginModal from "@/components/common/user-credentials/LoginModal";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";

const FinanceAndClosing = ({
  accordionState,
  sellerParameters,
  listingId,
  bidAmount,
  contigency,
  userId,
  afbaUrl,
  isAgent,
  propertyId,
  listingStatus,
  offerType,
  offerDetails,
  setOfferDetails,
  currentOfferAmountDetail,
  setCurrentOfferAmountDetails,
  offerUserDetail,
  sellerConcession,
  setOfferSubmitted,
  setSubmitData,
  setAccordionState,
  propertyDetails,
  cifId,
  setPayloadData,
  userRole
}) => {
  const globalPopup = useSelector((state) => state.login);
  const [paymentType, setPaymentType] = useState(
    sellerParameters?.financingAndClosingParameters?.defaultPaymentType ||
      "CASH"
  );
  const licensedRef = useRef(null);
  const [loading,setLoading] = useState(false);

  const [closingAgentOptions, setClosingAgentOptions] = useState([]);

  const [isOfferContigent, setIsOfferContigent] = useState("");
  const [financeType, setFinanceType] = useState("");
  const [financeTypeData, setFinanceTypeData] = useState({});
  const [loanAmount, setLoanAmount] = useState("");
  const [error, setError] = useState({});
  const [percentOffer, setPercentOffer] = useState("0.00");
  const [preApproved, setPreApproved] = useState("");
  const [preApprovalData, setPreApprovalData] = useState({
    institute: "",
    amount: "",
  });
  const [closingOption, setClosingOption] = useState([]);
  const [partyType, setPartyType] = useState("SELLER_PAYS");
  const [closingAgentDetails, setClosingAgentDetails] = useState({});
  const [titleInsuranceDetails, setTitleInsuranceDetails] = useState({});
  const [disable, setDisable] = useState(true);
  const [closingDays, setClosingDays] = useState("");
  const [offerValidFor, setOfferValidFor] = useState("");
  const [selectVendor, setSelectVendor] = useState(false);
  const [sellerContigency, setSellerContigency] = useState(contigency);
  const [sellerContingencyDays, setSellerContigencyDays] = useState({
    inspectionDay: "",
    financingDay: "",
  });
  const [sellerData, setSellerData] = useState([]);
  const [financeCheck, setFinanceCheck] = useState(false);
  const [earnestDeposite, setEarnestDeposite] = useState("");
  const [afBaAccepted, setAfbaAccepted] = useState(false);
  const [tnc, setTnc] = useState(false);
  const [listingError, setLisitingError] = useState("");
  const buyerFormRef = useRef();
  const agentFormRef = useRef();
  const [bidInspectionCont,setBidInspectionCont] = useState(true)
  const [earnestDepositeBlur,setEarnestDepositeBlur] = useState(true);
  const [saveClosingState,setSaveClosingState] = useState({})
  const [show,setShow] = useState(false)
  const [loanAmountBlur,setLoanAmountBlur] = useState(false);
  const [isALReoAcknowledgmentAccepted,setIsALReoAcknowledgmentAccepted] = useState(false);
  const [buyerTech,setBuyerTech] = useState("")
  const [preAmountBlur,setPreAmountBlur] = useState(false);
  const [bidInspectionError,setBidInspectionError] = useState("")
  const dispatch = useDispatch();


  const regexPatterns = {
    amount: /^\d+(\.\d{1,})?$/,
    institute: /^[a-zA-Z0-9&()\-,'\s]{1,50}$/,
  };

  const handleFinanceType = (e) => {
    setFinanceType(e.target.value);
    getFinanceData(e.target.value);
  };
  const handleLoanAmount = (e) => {
    const { value } = e.target;
    const numericRegex = /^\d*\.?\d*$/;
    if (!numericRegex.test(value)) return;
    setLoanAmount(value);
  };

  const handleBlur = (e) => {
    const value = loanAmount;
    setLoanAmountBlur(true)
    if (value.trim() === "") {
      setLoanAmount("");
      setPercentOffer("0.00");
      setError({ ...error, loanError: "Please indicate your amount." });
      return;
    }

    const numericValue = Number(value);

    if (isNaN(numericValue)) {
      setError({ ...error, loanError: "Please indicate a valid number." });
      return;
    }

    setLoanAmount(numericValue);
    const loanPercentage = parseFloat((numericValue / bidAmount) * 100).toFixed(
      2
    );
    setPercentOffer(loanPercentage);
    if (numericValue > bidAmount) {
      setError({ ...error, loanError: "Amount can't exceed offer amount" });
    } else if (loanPercentage < sellerParameters?.minBidFinancingPercent) {
      setError({
        ...error,
        loanError: `Loan must be at least ${sellerParameters.minBidFinancingPercent}% of offer amount`,
      });
    } else if (loanPercentage > sellerParameters?.maxBidFinancingPercent) {
      setError({
        ...error,
        loanError: `Your loan can't exceed ${sellerParameters.maxBidFinancingPercent}% of offer amount`,
      });
    } else {
      setError({ ...error, loanError: "" });
      setPercentOffer(loanPercentage);
    }
  };

  const renderDetailsForm = (
    title,
    stateData,
    disableFields,
    fields,
    isOptional,
    setStateData,
    mandatoryFields,
    onErrorChange,
    formRef
  ) => (
    <>
      <h6 className="form-title-buyeragent">{title}</h6>
      <DetailsForm
        disableAllFields={disableFields}
        fields={fields}
        stateData={stateData}
        setStateData={setStateData}
        mandatoryFields={mandatoryFields}
        setDisable={setDisable}
        onErrorChange={onErrorChange}
        ref={formRef}
      />
    </>
  );
  const bidCont = async (value) => {
    try {
      const details = await bidContigencyType({
        listingId,
        amount: bidAmount,
        type: value,
      });
      setSellerContigency(details);
    } catch (error) {
      console.log(error);
    }
  };
  const getFinanceData = async (value) => {
    try {
      const data = await financeEmd({
        listingId,
        amount: bidAmount,
        type: value,
      });
      setFinanceTypeData(data);
      setEarnestDeposite(data.earnestMoneyDeposit);
      bidCont(value);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    let type =
      sellerParameters?.financingAndClosingParameters
        ?.paymentTypeClosingOptionMap[paymentType];
    const d =
      sellerParameters?.financingAndClosingParameters?.closingOptionDetails?.filter(
        (e) => type?.includes(e.closingOption)
      );
    setClosingOption(d);
    if (paymentType === "CASH" && bidAmount > 0) {
      setPartyType(d[0]?.closingOption);
      getFinanceData(paymentType);
    }
    if(paymentType === "MORTGAGE"){
      // setPartyType("SELLER_PAYS")
      setPartyType(d[0]?.closingOption);
    }
  }, [paymentType, sellerParameters]);

  useEffect(() => {
    if (bidAmount > 0 && paymentType === "CASH") {
      getFinanceData(paymentType);
    }
  }, [bidAmount]);

  // Tooltip adjustment
useEffect(() => {
  const adjustTooltipPosition = () => {
    const tooltipContainers = document.querySelectorAll('.tooltip-container');

    tooltipContainers.forEach(container => {
      const tooltip = container.querySelector('.tooltip-text');
      if (!tooltip) return;

      const containerRect = container.getBoundingClientRect();
      const tooltipWidth = 200; // Default tooltip width
      const margin = 10; // Margin from screen edge

      // Reset to default positioning
      tooltip.style.left = '50%';
      tooltip.style.right = 'auto';
      tooltip.style.transform = 'translateX(-50%)';

      // Check if tooltip would overflow on the right
      if (containerRect.left + tooltipWidth / 2 > window.innerWidth - margin) {
        tooltip.style.left = 'auto';
        tooltip.style.right = '0';
        tooltip.style.transform = 'none';
      }

      // Check if tooltip would overflow on the left
      if (containerRect.left - tooltipWidth / 2 < margin) {
        tooltip.style.left = '0';
        tooltip.style.right = 'auto';
        tooltip.style.transform = 'none';
      }
    });
  };

  // Adjust on mount and window resize
  adjustTooltipPosition();
  window.addEventListener('resize', adjustTooltipPosition);
  window.addEventListener('scroll', adjustTooltipPosition);

  return () => {
    window.removeEventListener('resize', adjustTooltipPosition);
    window.removeEventListener('scroll', adjustTooltipPosition);
  };
}, []);


  const submitDetails = async () => {
       const isSessionValid = await isValidSession();
		    const isValid = isSessionValid.data?.isValidSession;
    if (isValid === "Y"){

    const newErrors = {};
    const buyerErrors = buyerFormRef.current?.validateAllFields?.() || {};
    const agentErrors = agentFormRef.current?.validateAllFields?.() || {};
    if (paymentType === "MORTGAGE") {
      if (financeType.length === 0) {
        newErrors.financeType = "Please select financing type.";
      }
      if(!isOfferContigent){
          newErrors.isOfferContigent ="Mandatory field"
      }
      if (loanAmount.length === 0) {
        newErrors.loanError = "Please indicate your amount.";
      }
      if(preApproved?.length===0){
        newErrors.preApproved = "Mandatory field"
      }
      if (preApproved === "Yes") {
        if (preApprovalData.institute.length === 0) {
          newErrors.institute = "Please select pre approval institute.";
        }
        if (preApprovalData.amount.length === 0) {
          newErrors.amount = "Please indicate your amount.";
        }
      } else {
        if (!selectVendor) {
          newErrors.selectVendor = "Please read and check the above box.";
        }
      }
    }

    if (
      paymentType === "CASH" ||
      (paymentType === "MORTGAGE" && partyType === "SELLER_PAYS")
    ) {
      if (closingDays?.length === 0 && paymentType==="CASH") {
        newErrors.closingDays = "Please specify number of days.";
      }
    }
     if (closingDays?.length === 0 &&( paymentType==="CASH" || (paymentType==="MORTGAGE" && financeType.length>0))) {
        newErrors.closingDays = "Please specify number of days.";
      }

    if (offerValidFor.length === 0) {
      newErrors.offerValidFor = "Please specify number of days.";
    }
    if (!tnc) {
      newErrors.tnc = "Please read and agree to the above statement";
    }
    if(!isALReoAcknowledgmentAccepted &&  propertyDetails?.address?.state==="AL" && sellerParameters?.propertyCategory ==="REO"){
      newErrors.alreo = "Please read and agree to the above statement";
    }
    if(!afBaAccepted){
      newErrors.afba = "Please read and agree to the above statement";
    }
    setError(newErrors);

    if (Object.keys(newErrors).length > 0) {
      licensedRef.current?.focus();
      return;
    }

    setLoading(true)
    const payload1 = {
      listingId,
      isAgent: isAgent,
      ...(sellerParameters?.propertyCategory ==="REO"  && { isALReoAcknowledgmentAccepted: isALReoAcknowledgmentAccepted?"Y":"N" }),
      currentOfferAmountDetail: {
        ...financeTypeData,
        offerAmount: bidAmount,
        earnestMoneyDeposit: earnestDeposite,
        earnestMoneyDepositFormatted: formatCurrency(earnestDeposite),
        earnestMoneyMessage: "",
      },
      offerDetail: {
        ...offerDetails,
        id: null,
        value: null,
        previousBidId: null,
        previousBidAmountFormatted: null,
        isLibertySelected: false,
        finacingAndClosingDetail: {
          id: null,
          value: null,
          paymentTypeSelected: [paymentType],
          paymentOptionsSelected: financeType ? [financeType] : null,
          loanAmount: Number(loanAmount) === 0 ? null : Number(loanAmount),
          loanAmountPercentage: percentOffer === "0.00" ? null : percentOffer,
          isBPFinanced: preApproved === "Yes" ? true : false,
          loanPreApprovalDetail:
            paymentType === "CASH"
              ? null
              : {
                  isPreApprovedForFinance:
                    preApprovalData.institute?.length > 0 ? true : false,
                  preApprovalVendorKeySelected: null,
                  institutionName:
                    preApprovalData.institute?.length > 0
                      ? preApprovalData.institute
                      : null,
                  preApprovedAmount:
                    preApprovalData.amount?.length > 0
                      ? preApprovalData.amount
                      : null,
                  preApprovedAmountFormatted:
                    preApprovalData.amount?.length > 0
                      ? formatCurrency(preApprovalData.amount)
                      : null,
                },
          closingOptionDetailSelected: {
            closingOption: partyType?.length>0 ? partyType : "SELLER_PAYS",
            closingOptionLabel: null,
            isClosingAgentRequired: null,
            isTitleInsuranceProviderRequired: null,
            // closingAgentDetail:null,
            closingAgentDetail:
              Object.keys(closingAgentDetails).length === 0
                ? null
                : closingAgentDetails,
            // titleInsuranceProviderDetail:null,
            titleInsuranceProviderDetail:
              Object.keys(titleInsuranceDetails).length === 0
                ? null
                : titleInsuranceDetails,
          },
          closingDaysSelected: closingDays,
        },
        offerExpiryDays: offerValidFor,
        // contingentUponFlag: isOfferContigent === "Yes" ? "Y" : "N",

        userId: userId,
        submittedByUserId: userId,
      },
      propertyId: propertyId,
      listingStatus: listingStatus,
      sellerConcession: sellerConcession,
      offerUserDetail: offerUserDetail,
      bidContigencyMasterList: sellerContigency,
      bidContigencyBuyerChosen:
      //  sellerData.length > 0
      //     ? sellerData
      //     :sellerContigency?.length===2? sellerContigency?.[1]:[sellerContigency?.[1],sellerContigency?.[2]]
      //     ? [sellerContigency?.[1]]
      //     : [],
      sellerData.length > 0
    ? sellerData
    : sellerContigency?.length === 2
      ? [sellerContigency[1]]
      : sellerContigency?.length === 3
        ? [sellerContigency[1], sellerContigency[2]]
        : [],
      offerType: offerType,
      afBaAccepted,
      cifId: cifId || "",
    };
    const payload2 = {
  listingId,
      isAgent: isAgent,
      ...(sellerParameters?.propertyCategory ==="REO"  && { isALReoAcknowledgmentAccepted: isALReoAcknowledgmentAccepted?"Y":"N" }),
      currentOfferAmountDetail: {
        ...financeTypeData,
        offerAmount: bidAmount,
        earnestMoneyDeposit: earnestDeposite,
        earnestMoneyDepositFormatted: formatCurrency(earnestDeposite),
        earnestMoneyMessage: "",
      },
      offerDetail: {
        ...offerDetails,
        id: null,
        value: null,
        previousBidId: null,
        previousBidAmountFormatted: null,
        isLibertySelected: false,
        finacingAndClosingDetail: {
          id: null,
          value: null,
          paymentTypeSelected: [paymentType],
          paymentOptionsSelected: financeType ? [financeType] : null,
          loanAmount: Number(loanAmount) === 0 ? null : Number(loanAmount),
          loanAmountPercentage: percentOffer === "0.00" ? null : percentOffer,
          isBPFinanced: preApproved === "Yes" ? true : false,
          loanPreApprovalDetail:
            paymentType === "CASH"
              ? null
              : {
                  isPreApprovedForFinance:
                    preApprovalData.institute?.length > 0 ? true : false,
                  preApprovalVendorKeySelected: null,
                  institutionName:
                    preApprovalData.institute?.length > 0
                      ? preApprovalData.institute
                      : null,
                  preApprovedAmount:
                    preApprovalData.amount?.length > 0
                      ? preApprovalData.amount
                      : null,
                  preApprovedAmountFormatted:
                    preApprovalData.amount?.length > 0
                      ? formatCurrency(preApprovalData.amount)
                      : null,
                },
          closingOptionDetailSelected: {
            closingOption: partyType?.length>0 ? partyType : "SELLER_PAYS",
            closingOptionLabel: null,
            isClosingAgentRequired: null,
            isTitleInsuranceProviderRequired: null,
            closingAgentDetail:
              Object.keys(closingAgentDetails).length === 0
                ? null
                : closingAgentDetails,
            // closingAgentDetail:null,
            // titleInsuranceProviderDetail:null,
            titleInsuranceProviderDetail:
              Object.keys(titleInsuranceDetails).length === 0
                ? null
                : titleInsuranceDetails,
          },
          closingDaysSelected: closingDays,
        },
        offerExpiryDays: offerValidFor,
        // contingentUponFlag: isOfferContigent === "Yes" ? "Y" : "N",

        userId: userId,
        submittedByUserId: userId,
      },
      propertyId: propertyId,
      listingStatus: listingStatus,
      sellerConcession: sellerConcession,
      offerUserDetail: offerUserDetail,
      bidContigencyMasterList: sellerContigency,
      bidContigencyBuyerChosen:
        sellerData.length > 0
    ? sellerData
    : sellerContigency?.length === 2
      ? [sellerContigency[1]]
      : sellerContigency?.length === 3
        ? [sellerContigency[1], sellerContigency[2]]
        : [],
      offerType: offerType,
      afBaAccepted,
      cifId: cifId || "",
    }
    trackButtonClick({
      eventName: "offer_options_next",
      eventSource: "Continue Button Click",
      eventCategory: "New-Offer Wizard",
      eventLabel: `Listing Id: ${listingId} | Payment Option : ${paymentType} |Closing: ${partyType}`,
      eventParams: {
        offer_type: offerType === "PLACE_OFFER" ? "offer" : "backup_offer",
      },
    });
const payload = sellerParameters?.propertyCategory !=="REO"? payload1:payload2

    const data = await submitOffer({ payload});
    if (data.errorMessage === null) {
      setPayloadData(payload)
      setLoading(false)
      setOfferSubmitted(true);
      setSubmitData(data);
      trackApiCall({
        eventName: "offer_confirmed_success",
        eventCategory: "New-Offer Wizard",
        eventLabel: `Listing Id: ${listingId}`,
      });
    } else {
      setLisitingError(data.errorMessage);
       setLoading(false)
    }
  }
    else{
		   toast.error("current session not valid, Please login again");
        batch(() => {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
        });
         setLoading(false);
		}
  };
  useEffect(() => {
    // getFinanceData(paymentType);
    setSellerContigency(contigency);
    getLabelData();
  }, [
    paymentType,
    sellerParameters?.financingAndClosingParameters?.paymentType,
    contigency,
  ]);

  const renderDays = (min, max, text) => {
    return Array.from({ length: max - min + 1 }, (_, index) => min + index).map(
      (day) => (
        <option key={day} value={day}>
          {day} {text}
        </option>
      )
    );
  };
  const parseString = (str) => {
    const regex = /<span[^>]*>(\$[\d,]+)<\/span>/g;

    return str?.split(regex).map((part, index) => {
      if (index % 2 === 1) {
        return <b key={index}>{part}</b>;
      }
      return part;
    });
  };
  const handleEarnestDeposite = (e) => {
    const value = e.target.value;
    setEarnestDeposite(value);
    setError({ ...error, earnestDeposite: "" });
  };
  const handleEarnestDepositeBlur = () => {
    const value = parseFloat(earnestDeposite);
    setEarnestDepositeBlur(true)
    const offerAmount = parseFloat(financeTypeData.offerAmount);
    const minEarnest = parseFloat(financeTypeData.earnestMoneyDeposit);

    if (isNaN(value)) {
      setError({
        ...error,
        earnestDeposite: "Please enter a valid number.",
      });
    } else if (value > offerAmount) {
      setError({
        ...error,
        earnestDeposite: `Based on your offer, this amount must be below ${financeTypeData?.offerAmountFormatted}`,
      });
    } else if (value < minEarnest) {
      setError({
        ...error,
        earnestDeposite: `Based on your offer, this amount must be at least ${financeTypeData?.earnestMoneyDepositFormatted}`,
      });
    } else {
      setError({ ...error, earnestDeposite: "" });
    }
  };
  function formatCurrency(number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);
  }
 const sellerContigencyDataForApi = (data, value) => {
const isDateString = (val) =>
    typeof val === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(val);
  const getNumberOfDaysFromToday = (dateStr) => {
    const today = new Date();
    const target = new Date(dateStr);
    const diffTime = target.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0);
     return Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
  };

  const numberOfDays = isDateString(value) ? getNumberOfDaysFromToday(value) : Number(value);

  const updatedData = {
    ...data,
    maxNumberOfDays: numberOfDays,
    comment: data.comment?.replace("{date}", numberOfDays),
  };

  setSellerData((prevData) => {
    const updatedList = prevData.map((item) =>
      item.sellerId === updatedData.sellerId && item.contingencyType === updatedData.contingencyType
        ? updatedData
        : item
    );
    const exists = prevData.some(
      (item) =>
        item.sellerId === updatedData.sellerId &&
        item.contingencyType === updatedData.contingencyType
    );

    const finalList = exists ? updatedList : [...updatedList, updatedData];

    if (sellerContigency.length === 3) {
      const alreadyAdded = finalList.some(
        (item) =>
          item.sellerId === sellerContigency[2].sellerId &&
          item.contingencyType === sellerContigency[2].contingencyType
      );

      if (!alreadyAdded) {
        finalList.push(sellerContigency[2]);
      }
    }

    return finalList;
  });
};

  const handleInstitueBlur = (e) => {
    const { name, value } = e.target;

    const pattern = regexPatterns[name];

    if (!value.trim()) {
      setError((prev) => ({
        ...prev,
        [name]:
          name === "amount"
            ? "Please indicate your amount."
            : "Invalid Institution name",
      }));
    } else if (!pattern.test(value)) {
      const message =
        name === "amount"
          ? "Please indicate your amount."
          : "Invalid Institution name";
      setError((prev) => ({ ...prev, [name]: message }));
    } else {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
    if(name==="amount"){
        setPreAmountBlur(true)
    }
  };
  const formatCurrencyBlur = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return "";
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits:0
    });
  };
const handleClose =() =>setShow(false)
  const openSaveClosing = (price,state) =>{
      setShow(true)
      setSaveClosingState({price,state})
  }
    const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"
    ];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  useEffect(()=>{
    if(paymentType==="CASH"){
      setFinanceType("")
    }
    getLabelData()
  },[paymentType])

  // const getLabelData = () => {

  //     const type = propertyDetails?.commonAttributes?.propCategory;
  //     const targetObject = OfferDataForSeller.find((item) => item[propertyDetails?.sellerId]);
  //     setClosingAgentOptions(
  //       targetObject?.[propertyDetails?.sellerId]?.[type]?.[paymentType]
  //     );
  //   };
  const getLabelData = () => {
  const sellerId = propertyDetails?.sellerId;
  const category = propertyDetails?.commonAttributes?.propCategory;
  let targetObject = spbpDescText.find(item => item[sellerId]);
  if (!targetObject) {
    console.warn(`Seller ID "${sellerId}" not found in spbpDescText. Falling back to DEFAULT.`);
    targetObject = spbpDescText.find(item => item["DEFAULT"]);
  }
  const data =
    targetObject?.[sellerId]?.[category]?.[paymentType] ??
    targetObject?.["DEFAULT"]?.[category]?.[paymentType];

  if (!data) {
    console.error(`Data not found for sellerId "${sellerId}", category "${category}", and paymentType "${paymentType}"`);
  }

  setClosingAgentOptions(data);
};

  return (
    <div className="accordion-item mb-2 border rounded">
      {globalPopup?.loginModal && <LoginModal popUpMsg={true}/>}
      <h2 className="accordion-header p-1" id="flush-heading-financeclosing">
        <button
          className={`accordion-button ${
            accordionState?.accordion3?.close ? "collapsed" : ""
          } ${
            accordionState?.accordion3?.close &&
            accordionState?.accordion3?.edit
              ? "no-caret"
              : ""
          }`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapse-financeclosing"
          aria-expanded="false"
          id="acc5"
          aria-controls="flush-collapse-financeclosing"
          disabled={accordionState?.accordion3?.disable}
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <p className="d-flex align-items-center mb-0 offer-acc-title">
              {" "}
              <p className="accordion-number mb-0">3</p> Financing And Closing{" "}
            </p>
          </div>
        </button>
      </h2>
      <div
        id="flush-collapse-financeclosing"
        className={`accordion-collapse collapse ${
          accordionState?.accordion3?.close ? "" : "show"
        }`}
        aria-labelledby="flush-heading-financeclosing"
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body">
            {listingError.length > 0 && listingError==="Listing has been closed."&& (
            <p className="error-offer alert alert-danger"><MdError color="#a94442" size="22px"/>
{listingError}</p>
          )}
          <div className="finance-closing">
            <div className="financing-home">
              <div className="justify-content-end d-flex align-items-center">
                <span className="mandatory pt-1">*</span> <i className="fs-11 color-mandaoty-line"> Indicates Required Fields</i>
              </div>
              {sellerParameters?.financingAndClosingParameters?.paymentType
                ?.length === 1 ? (
                <div className=" mb-3">
                  <p className="finance-title">
                    How will you be Financing this home?{" "}
                    <span className="mandatory">*</span>
                  </p>
                  <span className="finance-ans">Cash Only</span>
                </div>
              ) : (
                <RadioButtonGroup
                  title="How will you be Financing this home? "
                  mandatory={true}
                  options={[
                    { label: "Cash", value: "CASH", id: "finance-title-c"},
                    { label: "Mortgage", value: "MORTGAGE", id: "finance-title-m" },
                  ]}
                  selectedValue={paymentType}
                  onChange={setPaymentType}
                />
              )}
              {sellerParameters?.financingAndClosingParameters?.paymentType
                ?.length !== 1 && (
                <div className="payment-type-selection-data">
                  {paymentType === "CASH" ? (
                    <p className="cash-note">
                      Note: Changing cash offers to financing after the property
                      is under contract may result in loss of deposit. The
                      Seller may reject such a change at their sole discretion.
                    </p>
                  ) : (
                    <div className="mortgage-type">
                      <div className="offer-contigent flex">
                        <RadioButtonGroup
                          title="Is your offer contingent upon obtaining financing? "
                          mandatory={true}
                          options={[
                            { label: "Yes", value: "Yes", id: "mortgage-type-yes"},
                            { label: "No", value: "No", id: "mortgage-type-no" },
                          ]}
                          selectedValue={isOfferContigent}
                          onChange={setIsOfferContigent}
                          tooltip={true}
                           onBlur={(e) => {
                            if (e.target.value !== "") {
                              setError({ ...error, isOfferContigent: "" });
                            }
                          }}
                        />
                        {
                          error?.isOfferContigent?.length>0 && <p className="error-offer mb-0">{error?.isOfferContigent}</p>
                        }
                      </div>
                      <div className="finance-type form-group flex">
                        <label className="agree-close-p mb-0 w-25 " htmlFor="financingTypeSel">
                          Type of Financing:{" "}
                          <span className="mandatory">*</span>
                        </label>
                        <select
                          id="financingTypeSel"
                          value={financeType}
                           ref={licensedRef}
                          className={`closingselect fin-select p-2 ml70 ${
                            error?.financeType?.length > 0 ? "border-error" : ""
                          }`}
                          onChange={handleFinanceType}
                          onBlur={(e) => {
                            if (e.target.value !== "") {
                              setError({ ...error, financeType: "" });
                            }
                          }}
                        >
                          <option value="">Select</option>
                          {sellerParameters?.financingAndClosingParameters?.mortgagePaymentOption?.map(
                            (data) => (
                              <option
                                key={data?.paymentOption}
                                value={data?.paymentOption}
                              >
                                {data.label}
                              </option>
                            )
                          )}

                        </select>
                        {error.financeType?.length > 0 && (
                          <p className="error-offer mb-0">{error.financeType}</p>
                        )}
                      </div>
                      <div className="loan-amount flex mt-3">
                        <label
                          htmlFor="loan-amount"
                          className="agree-close-p mb-0 w-25"
                        >
                          Loan Amount <span className="mandatory">*</span>
                        </label>
                        <div className="ml90">
                          <input
                            type="text"
                             ref={licensedRef}
                            id="loan-amount"
                            className={`form-control loan-input h-25 ${
                              error.loanError ? "border-error" : ""
                            }`}
                            value={loanAmountBlur?formatCurrencyBlur(loanAmount):loanAmount}
                            onChange={(e) => handleLoanAmount(e)}
                            onBlur={(e) => handleBlur(e)}
                            onFocus={()=>setLoanAmountBlur(false)}
                            onKeyDown={handleKeyDown}
                          />
                          {error?.loanError?.length > 0 && (
                            <p className="error-offer">{error.loanError}</p>
                          )}
                        </div>
                        <p className="loan-percent">
                          {/* which is {!error.loanError ? "x" : percentOffer}% of
                        offer amount. */}
                          which is {percentOffer}% of offer amount.
                        </p>
                      </div>
                      <div className="pre-approved flex">
                        <RadioButtonGroup
                          title="Are you pre-approved for financing?"
                          mandatory={true}
                          options={[
                            { label: "Yes", value: "Yes", id: "pre-approved-yes" },
                            { label: "No", value: "No", id: "pre-approved-no" },
                          ]}
                          selectedValue={preApproved}
                          onChange={setPreApproved}
                          onBlur={() => {
  if (preApproved !== "") {
    setError({ ...error, preApproved: "" });
  }
}}

                        />
                        {
                          error?.preApproved?.length>0 && <p className="error-offer mb-0">{error?.preApproved}</p>
                        }
                      </div>
                      {preApproved === "Yes" ? (
                        <div className="pre-approval">
                          <div className="flex">
                            <label
                              htmlFor="pre-approval-insititue"
                              className="agree-close-p mb-0 w-25 "
                            >
                              Pre-approval Institution{" "}
                              <span className="mandatory">*</span>
                            </label>
                            {/* <div> */}
                              <input
                                type="text"
                                 ref={licensedRef}
                                id="pre-approval-insititue"
                                className={`form-control h-25 ml90 loan-input ${
                                  error?.institute?.length > 0
                                    ? "border-error"
                                    : ""
                                }`}
                                name="institute"
                                value={preApprovalData.institute}
                                onChange={(e) =>
                                  setPreApprovalData({
                                    ...preApprovalData,
                                    institute: e.target.value,
                                  })
                                }
                                onBlur={(e) => handleInstitueBlur(e)}
                              />
                              {error?.institute?.length > 0 && (
                                <p className="error-offer pt-3">{error.institute}</p>
                              )}
                            {/* </div> */}
                          </div>
                          <div className="flex">
                            <label
                              htmlFor="pre-approval-amount"
                              className="agree-close-p mb-0 w-25 "
                            >
                              Pre-approval Amount{" "}
                              <span className="mandatory">*</span>
                            </label>
                            {/* <div> */}
                              <input
                                type="text"
                                 ref={licensedRef}
                                className={`form-control h-25 ml90 loan-input ${
                                  error?.amount?.length > 0
                                    ? "border-error"
                                    : ""
                                }`}
                                name="amount"
                                id="pre-approval-amount"
                                value={preAmountBlur? formatCurrencyBlur(preApprovalData?.amount || ""):preApprovalData.amount}
                                onChange={(e) =>
                                  setPreApprovalData({
                                    ...preApprovalData,
                                    amount: e.target.value,
                                  })
                                }
                                onFocus={()=>setPreAmountBlur(false)}
                                onBlur={(e) => handleInstitueBlur(e)}
                                onKeyDown={handleKeyDown}
                              />
                              {error?.amount?.length > 0 && (
                                <p className="error-offer pt-3">{error.amount}</p>
                              )}
                            {/* </div> */}
                          </div>
                        </div>
                      ) : (
                        <>
                          {preApproved === "No" && (
                            <div className="mb-2">
                              <input
                                type="checkbox"
                                 ref={licensedRef}
                                name="select-vendor"
                                id="select-vendor"
                                aria-label="seller-contigency"
                                className="form-check-input mr5 "
                                value={selectVendor}
                                onChange={(e) =>
                                  setSelectVendor(e.target.checked)
                                }
                                onBlur={(e) => {
                                  if (e.target.checked == true) {
                                    setError({ ...error, selectVendor: "" });
                                  }
                                }}
                                />
                              <span className="agree-close-p">
                                I am currently working with a lender to get
                                pre-approved and will provide proof of
                                pre-approval when submitting the executed
                                contract.
                              </span>
                              {error?.selectVendor?.length > 0 && (
                                <p className="error-offer">
                                  {error.selectVendor}
                                </p>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
            {
            closingOption?.length>1 && <>
           {sellerParameters?.sellerHasPermission && (
                  <p className="title-insurance pt-4 pb-2">
                    Which party will cover title insurance and property search
                    fees?
                  </p>
                )}
            </>
          }
          {[...closingOption || []]
            // .sort((a, b) => {
            //   if (a.closingOption === 'SELLER_PAYS') return -1;
            //   if (b.closingOption === 'SELLER_PAYS') return 1;
            //   return 0;
            // })
            .map((data, index) => (
              <div className="closing-option " key={index}>
                {closingOption?.length === 1 ? (
                  <p>
                    <span className="label-fin ml10">
                      {closingAgentOptions?.[data?.closingOption]?.label} :{" "}
                    </span>
                    <span className="ml10 fin-p">
                      {/* {data?.closingOptionLabel === "Buyer Pays"
                        ? ReactHtmlParser(
                            `Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.`
                          )
                        : ""} */}
                        {ReactHtmlParser(
                        closingAgentOptions?.[data?.closingOption]?.text
                          ?.replace(/##STATEID##/g, data?.stateName)
                          ?.replace(/##AMOUNT##/g, data?.formatAmount)
                      )}
                    </span>
                  </p>
                ) : (
                  <div className="align-items-center">
                    <input
                      type="radio"
                      name="sellerBuyerPays"
                      id={data?.closingOption}
                        onChange={(e) => setPartyType(e.target.value)}
                        checked={partyType === data?.closingOption}
                           ref={licensedRef}
                          value={data?.closingOption}
                          className="form-check-input mx-2 mb-1"
                          onClick={()=>{if(data?.closingOption==="BUYER_PAYS"){openSaveClosing(data?.formatAmount,data.stateName)}}}
                    />
                    <label
                      className="label-fin"
                      htmlFor={data?.closingOption}
                    >
                      <strong className="label-fin">
                        {closingAgentOptions?.[data?.closingOption]?.label} :
                      </strong>
                    </label>
                    <span className="ml10 fin-p">
                      {ReactHtmlParser(
                        closingAgentOptions?.[data?.closingOption]?.text
                          ?.replace(/##STATEID##/g, data?.stateName)
                          ?.replace(/##AMOUNT##/g, data?.formatAmount)
                      )}
                    </span>
                  </div>
                )}
              </div>
            ))}

          {((partyType === "BUYER_PAYS" && closingOption?.length>1 )|| (closingOption?.length===1 && partyType === "BUYER_PAYS" && closingOption[0]?.isClosingAgentRequired===true)) && (
            <div className="row mt-2">
              <div className="col-md-6 col-sm-12">
                {renderDetailsForm(
                  "Closing Agent",
                  closingAgentDetails,
                  [],
                  ClosingAgent,
                  null,
                  setClosingAgentDetails,
                  [
                    "name",
                    "companyName",
                    "email",
                    "phone",
                  ],
                  setError,
                  buyerFormRef
                )}
              </div>
              <div className="col-md-6 col-sm-12">
                {renderDetailsForm(
                  "Title Insurance Provider",
                  titleInsuranceDetails,
                  [],
                  TitleInsuranceProvider,
                  true,
                  setTitleInsuranceDetails,
                  [],
                  setError,
                  agentFormRef
                )}
              </div>
            </div>
          )}
          {/* (paymentType === "CASH" ||
            (paymentType === "MORTGAGE" && partyType === "SELLER_PAYS") */}
          {(paymentType === "CASH" || (paymentType === "MORTGAGE" && financeType !== "")) && (
            <div className="agree-close-in flex align-items-center flex-wrap">
              <p
                className="agree-close-p mb-0 w-25 widthsm"
                title="An earlier closing date will make your offer more attractive to the seller"
              >
                You agree to close in
                {/* <div
                  className="cursor-pointer d-inline-block mb-0 info-tooltip-offer mx-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="An earlier closing date will make your offer more attractive to the seller"
                >
                  i
                </div> */}
                 <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">An earlier closing date will make your offer more attractive to the seller</div>
</div>
                <span className="mandatory">*</span>{" "}
              </p>
              <select
                name="closingDays"
                id="closingDays"
                 ref={licensedRef}
                className={`closingselect mx-2 ${
                  error?.closingDays?.length > 0 ? "border-error" : ""
                }`}
                value={closingDays || ""}
                onChange={(e) => {
                  setClosingDays(e.target.value);
                  setError({ ...error, closingDays: "" });
                }}
              >
                <option value="">Select</option>
                {sellerParameters?.financingAndClosingParameters?.closingDays?.map(
                  (data) => (
                    <>
                      {(data?.paymentOption === paymentType ||
                        data?.paymentOption === financeType) &&
                        renderDays(
                          data?.minimumClosingDays,
                          data?.maximumClosingDays,
                          "days"
                        )}
                    </>
                  )
                )}
              </select>
              {error?.closingDays?.length > 0 && (
                <p className="error-offer mb-0 mx-3">{error?.closingDays}</p>
              )}
            </div>
          )}
          <div className="offer-valid-for flex align-items-center py-4 flex-wrap">
            <p className="agree-close-p mb-0 w-25 widthsm">
              Offer Valid For <span className="mandatory">*</span>{" "}
            </p>
            <select
              className={`closingselect mx-2 ${
                error?.offerValidFor?.length > 0 ? "border-error" : ""
              }`}
               ref={licensedRef}
              name="offerExpiryDays"
              id="offerExpiryDays"
              value={offerValidFor || ""}
              onChange={(e) => {
                setOfferValidFor(e.target.value);
                setError({ ...error, offerValidFor: "" });
              }}
            >
              <option value="">Select</option>
              {renderDays(
                sellerParameters?.minimumOfferValidDays,
                sellerParameters?.maximumOfferValidDays,
                "days"
              )}
            </select>
            <p className="agree-close-p mb-0">from today.</p>
            {error?.offerValidFor?.length > 0 && (
              <p className="error-offer mb-0 mx-3">{error.offerValidFor}</p>
            )}
          </div>
          <div className="seller-contigency ">
            {(sellerContigency?.length > 1 || sellerParameters?.propertyCategory ==="REO")&& (
              <div className="seller-cont">
                {paymentType === "CASH" ||
                (paymentType === "MORTGAGE" && (isOfferContigent === "No" )) ? (
                  <>
                    <h5 className="seller-contigent">Seller Contingencies</h5>
                    <div className="flex align-items-center">
                      {sellerContigency?.[1]?.maxNumberOfDays > 0 && (
                        <input
                          type="checkbox"
                          name="seller-contigency-checkbox"
                          className="form-check-input"
                          id="seller-contigency-checkbox"
                          aria-label="seller-contigency-checkbox"
                          checked={bidInspectionCont}
                          onChange={(e)=>{setBidInspectionCont(e.target.checked);
                            if(e.target.checked===false){
                               setError({...error,bidInspectionCont:""})
                            }
                          }}
                        />
                      )}
                      {typeof sellerContigency?.[1]?.comment === "string" &&
                      sellerContigency?.[1]?.maxNumberOfDays > 0 ? (
                        sellerContigency?.[1]?.comment
                          .split("{date}")
                          .map((part, index) => {
                             const trimmedPart = part.trim();

      // Skip rendering if empty
      if (!trimmedPart) return null;
                            return (
                              <div className="d-flex seller-fin-title align-items-center mx-2 w-100 mt-1">
                                {part}
                                {index === 0 && (
                                  <>
                                  {
                                    sellerContigency?.[1]?.sellerId === "000" ?
                                    <>
                                      <input
                                      className={`${error?.bidInspectionCont?.length > 0 ? "border-error" : ""} p-1 mx-2 form-control  w-15`}
                                      type="date"
                                      name="sellerContingencyDays"
                                      aria-label="sellerContingencyDays"
                                      disabled={!bidInspectionCont}
                                             onChange={(e) => {
                                    sellerContigencyDataForApi(
                                      sellerContigency?.[1],
                                      e.target.value
                                    );
                                    setSellerContigencyDays({
                                      ...sellerContingencyDays,
                                      inspectionDay: e.target.value,
                                    });
                                  }}
                                  onBlur={(e)=>{
                                    if(e.target.value ==="" && bidInspectionCont){
                                      setError({...error,bidInspectionCont:"Please select Date"})
                                    }
                                  }}
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      max={
                                        new Date(
                                          Date.now() +
                                            (sellerContigency?.[1]
                                              ?.maxNumberOfDays ?? 0) *
                                              24 *
                                              60 *
                                              60 *
                                              1000
                                        )
                                          .toISOString()
                                          .split("T")[0]
                                      }
                                    />
                                    {error?.bidInspectionCont?.length > 0 && (
              <p className="error-offer mb-0 mx-3">{error.bidInspectionCont}</p>
            )}
                                    </>
                                    :
                                     <select
                                  name="sellerContingencyDays"
                                  // value={
                                  //   sellerContingencyDays?.inspectionDay || ""
                                  // }
                                   value={

                                        !bidInspectionCont?"":  sellerContingencyDays?.inspectionDay
                                      }
                                  disabled={!bidInspectionCont}
                                  className={"closingselect"}
                                  onChange={(e) => {
                                    sellerContigencyDataForApi(
                                      sellerContigency?.[1],
                                      e.target.value
                                    );
                                    setSellerContigencyDays({
                                      ...sellerContingencyDays,
                                      inspectionDay: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select</option>
                                  {renderDays(
                                    1,
                                    sellerContigency?.[1]?.maxNumberOfDays
                                  )}
                                </select>
                                  }

                                  </>
                                )}
                              </div>
                            );
                          })
                      ) : (
                        <p className="seller-fin-title">
                          {sellerContigency?.[1]?.comment}
                        </p>
                      )}
                    </div>
                    {sellerContigency?.length === 3 && (
                      <p className="seller-fin-title mt-2">
                        {sellerContigency?.[2]?.comment}
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    <h5 className="seller-contigent">Seller Contingencies</h5>
                    {sellerContigency?.map((data) => (
                      <div className="p-1 flex align-items-center mt-2">
                        {data?.maxNumberOfDays > 0 && (
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            className="seller-checkbox form-check-input"
                            aria-label="seller-checkbox"
                            disabled={data?.contingencyType === "FINANCING"}
                            checked={
      data?.contingencyType === "FINANCING"
        ? true
        : bidInspectionCont
    }
    onChange={(e) => {
      if (data?.contingencyType !== "FINANCING") {
        setBidInspectionCont(e.target.checked);
          if(e.target.checked===false){
          setError({...error,bidInspectionCont:""})
        }
      }
    }}
                          />
                        )}
                        <div className="seller-cont-map d-flex align-items-center mx-3 w-100 mt-1">
                          {data?.comment?.split("{date}").map((part, index) => {
                            return (
                              <>
                                {part}
                                {index === 0 && data?.maxNumberOfDays > 0 && (
                                  <>
                                  {
                                    data?.contingencyType==="INSPECTION"?
                                     <>
                                  {
                                    data?.sellerId === "000" ?
                                    <>
                                      <input
                                      type="date"
                                      name="sellerContingencyDays"
                                    className={`${error?.bidInspectionCont?.length > 0 ? "border-error" : ""} p-1 mx-2 form-control  w-15`}
                                      aria-label="sellerContingencyDays"
                                      disabled={!bidInspectionCont}
                                             onChange={(e) => {
                                    sellerContigencyDataForApi(
                                      sellerContigency?.[1],
                                      e.target.value
                                    );
                                    setSellerContigencyDays({
                                      ...sellerContingencyDays,
                                      inspectionDay: e.target.value,
                                    });
                                  }}
                                   value={

                                        !bidInspectionCont?"":  sellerContingencyDays?.inspectionDay
                                      }
                                       onBlur={(e)=>{
                                    if(e.target.value ==="" && bidInspectionCont){
                                      setError({...error,bidInspectionCont:"Please select Date"})
                                    }
                                  }}
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      max={
                                        new Date(
                                          Date.now() +
                                            (sellerContigency?.[1]
                                              ?.maxNumberOfDays ?? 0) *
                                              24 *
                                              60 *
                                              60 *
                                              1000
                                        )
                                          .toISOString()
                                          .split("T")[0]
                                      }
                                    />
                                      {error?.bidInspectionCont?.length > 0 && (
              <p className="error-offer mb-0 mx-3">{error.bidInspectionCont}</p>
            )}
                                    </>
                                    :
                                      <select
                                      name={`${
                                        data?.contingencyType === "FINANCING"
                                          ? "financingDay"
                                          : "inspectionDay"
                                      }`}
                                      value={
                                        data?.contingencyType === "FINANCING"
                                          ? sellerContingencyDays.financingDay
                                          : sellerContingencyDays?.inspectionDay ||
                                            ""
                                      }
                                      className="closingselect mx-2"
                                      onChange={(e) => {
                                        sellerContigencyDataForApi(
                                          data,
                                          e.target.value
                                        );

                                        setSellerContigencyDays({
                                          ...sellerContingencyDays,
                                          [e.target.name]: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">Select </option>
                                      {renderDays(1, data?.maxNumberOfDays)}
                                    </select>
                                  }

                                  </>
                                    :
                                    <select
                                      name={`${
                                        data?.contingencyType === "FINANCING"
                                          ? "financingDay"
                                          : "inspectionDay"
                                      }`}
                                      value={
                                        data?.contingencyType === "FINANCING"
                                          ? sellerContingencyDays.financingDay
                                          : sellerContingencyDays?.inspectionDay ||
                                            ""
                                      }
                                      className="closingselect mx-2"
                                      onChange={(e) => {
                                        sellerContigencyDataForApi(
                                          data,
                                          e.target.value
                                        );

                                        setSellerContigencyDays({
                                          ...sellerContingencyDays,
                                          [e.target.name]: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">Select </option>
                                      {renderDays(1, data?.maxNumberOfDays)}
                                    </select>
                                  }
                                  </>
                                )}
                              </>
                            );
                          })}
                        </div>
                        {/* {data.contingencyType === "TITLE" && (
                        <p>{data?.comment}</p>
                      )} */}
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
            {sellerParameters?.libertyProgramEnabled && (
              <div className="loans-financing">
                <h5>Loans And Financing</h5>
                <div className="d-flex">
                  <input
                    type="checkbox"
                    name="financeCheck"
                    className="form-check-input"
                    aria-label="financeCheck"
                    id="financeCheck"
                    value={financeCheck || ""}
                    onChange={(e) => setFinanceCheck(e.target.checked)}
                  />
                  <p className="seller-fin-title mx-2">
                    I authorize Altisource Fulfilment Operations, Inc. and its
                    affiliates, to share my information with a third party
                    lender who may contact me by email or phone.
                  </p>
                </div>
                <span className="px-4 seller-fin-title">
                  This advertisement is provided by an affiliate of Altisource
                  Online Auctions, Inc., Altisource Fulfilment Operations, Inc.
                </span>
              </div>
            )}
    <div className="mt-3 border-bottom pb-3 mx-">

            {paymentType === "MORTGAGE" && isOfferContigent === "No" && (
              <p className="seller-fin-title">
                <li>
                This sale is not contingent on the buyer obtaining financing.

                </li>
              </p>
            )}
            <p className="seller-fin-title">
              <li>

              Final acceptance of an offer is not complete without the Seller's
              signature on the Purchase and Sale Agreement.
              </li>
            </p>
    </div>

            <div className="p-4 pb-2">
              {paymentType === "CASH" ? (
                <p className="title-buyer-no">
                  NO, Buyer does not want to finance the Technology Fee.
                  <p className="pt-2 cash-trasnsaction">
                    * this is a cash transaction
                  </p>
                </p>
              ) : (
                <>
                  <div className="d-flex">
                    <input
                      type="radio"
                      name="buyer-finance"
                      aria-label="buyer-finance-y"
                      id=""
                      value={"Yes"}
                      checked={buyerTech==="Yes"}
                      className="form-check-input"
                      onChange={(e)=>setBuyerTech("Yes")}
                    />{" "}
                    <p className="title-buyer-no mx-2">
                      YES, Buyer wants to finance the Technology Fee.{" "}
                    </p>
                  </div>
                  <p className="mx-3 cash-trasnsaction">
                    * this is a transaction involving financing by a lender, and
                    Buyer wants to finance the fee
                  </p>
                  <div className="d-flex">
                    <input
                      type="radio"
                      name="buyer-finance"
                      aria-label="buyer-finance-n"
                      id=""
                      className="form-check-input"
                      value={"No"}
                      checked={buyerTech==="No"}
                      onChange={(e)=>setBuyerTech("No")}
                    />{" "}
                    <p className="title-buyer-no mx-2">
                      {" "}
                      NO, Buyer does not want to finance the Technology Fee.
                    </p>
                  </div>
                  <p className="mx-3 cash-trasnsaction">
                    * this is a transaction involving financing, but Buyer does
                    not want to finance the fee
                  </p>
                </>
              )}
            </div>
            <div className="earnest-deposit mt-2">
              <p className="earnest-title mb-0">
                Earnest Money Deposit{" "}
                {/* <div
                  className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={`You may designate an Earnest Money Deposit between ${financeTypeData?.earnestMoneyDepositFormatted} and ${financeTypeData?.totalDuesFormatted}`}
                >
                  i
                </div> */}
                <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">You may designate an Earnest Money Deposit between {financeTypeData?.earnestMoneyDepositFormatted} and {financeTypeData?.totalDuesFormatted}</div>
</div>
              </p>
              <div className="w-50">
                <input
                  type={earnestDepositeBlur ? "text" : "number"}
                  name="earnestDeposite"
                  aria-label="earnestDeposite"
                  className={`form-control w-25 h-25 widthsm ${
                    error?.earnestDeposite?.length > 0 ? "border-error" : ""
                  }`}
                  // value={earnestDeposite}
                   value={earnestDepositeBlur ? formatCurrencyBlur(earnestDeposite) : earnestDeposite}
                  onChange={handleEarnestDeposite}
                  onBlur={handleEarnestDepositeBlur}
                  onFocus={()=>setEarnestDepositeBlur(false)}
                />

                {error?.earnestDeposite?.length > 0 && (
                  <p className="error-offer">{error?.earnestDeposite}</p>
                )}
              </div>
            </div>
            <div className="border-bottom p-2 bg-light">
              <p className="earnest-note">
                <b>Note : </b>
                {parseString(financeTypeData?.earnestMoneyMessage)}
              </p>
            </div>
          </div>

          <div className="tnc pt-3">
            {
              paymentType === "MORTGAGE" &&
              <div className="disc-mortgage mb-4">
                <strong>Disclaimer:</strong> Any repairs to the Property identified by the Buyer or which may be required by any lending institution to which the Buyer may have applied ("Repairs") are the responsibility of the Buyer. The seller may evaluate repair requests but is under no obligation to make any repairs to the property. Buyer agrees not to enter the Property prior to Closing for the purpose of making any repairs or alterations without the Seller's express written consent.

              </div>
            }
                  {
                   (sellerParameters?.propertyCategory ==="REO" && propertyDetails?.address?.state==="AL")&&
                   <>
                 <div className="d-flex mb-2">
              <input
                type="checkbox"
                className="form-check-input mt-0"
                name="alreo"
                id="alreo"
                aria-label="alreo"
                value={isALReoAcknowledgmentAccepted}
                checked={isALReoAcknowledgmentAccepted}
                onChange={(e) => setIsALReoAcknowledgmentAccepted(e.target.checked)}
                onBlur={e=>{
                  if(e.target.checked===true){
                    setError({...error,alreo:""})
                  }
                }}
              />
              <p className="mx-3 mb-0 tnc-p">
              Each bid placed on Hubzu constitutes a written offer or counteroffer. The property page provides, among other information, property details and disclosures. Upon entering a bid on HUBZU, buyers and sellers acknowledge receipt of any offer, counteroffer, or disclosure.

              </p>
            </div>
             {error.alreo?.length > 0 && (
              <p className="error-offer mb-0">{error?.alreo}</p>
            )}
            </>
                  }
            <div className="d-flex">
              <input
                type="checkbox"
                className="form-check-input mt-0"
                name="tnc"
                id="tnc"
                aria-label="tnc"
                checked={tnc}
                onChange={(e) => setTnc(e.target.checked)}
                onBlur={e=>{
                  if(e.target.checked===true){
                    setError({...error,tnc:""})
                  }
                }}
              />
              <p className="mx-3 tnc-p">
                {
                  userRole==="Agent"? <>I represent the buyer for this transaction and on their behalf, </>:<>
                  </>
                }
                I have read and understand the above information and acknowledge
                that the terms of the Purchase and Sale Agreement, once signed
                by the buyer and seller, will control this transaction. I agree
                to the Hubzu{" "}
                <a href="/about/terms" className="tnc-a" target="_blank">
                  Terms and Conditions
                </a>
                ,{" "}
                <a
                  href="https://www.altisource.com/Privacy-Policy/"
                  target="_blank"
                  className="tnc-a"
                >
                  PRIVACY Policy
                </a>{" "}
                and any Special Terms that may apply.
              </p>
            </div>
            {error.tnc?.length > 0 && (
              <p className="error-offer mb-3">{error?.tnc}</p>
            )}
            <div className="d-flex mb-1">
              <input
                type="checkbox"
                className="form-check-input mt-0"
                name="afba"
                id="afba"
                aria-label="afba"
                checked={afBaAccepted}
                onChange={(e) => setAfbaAccepted(e.target.checked)}
                onBlur={e=>{
                  if(e.target.checked===true){
                    setError({...error,afba:""})
                  }
                }}
              />
              <p className="mx-3 mb-0 tnc-p">
                I have read and understand the disclosures found in the
                Affiliated Business Arrangement Disclosure Statement found{" "}
                <a target="_blank" href={afbaUrl} className="tnc-a">
                  {" "}
                  here
                </a>
              </p>
            </div>
            {error?.afba?.length > 0 && (
              <p className="error-offer mb-0">{error?.afba}</p>
            )}
          </div>
          <button
            // disabled={disableButton()}
            onClick={submitDetails}
            className="offer-btn btn  mt-3"
            disabled={loading}
          >
            {" "}
         {loading?"Confirm Offer..." :"Confirm Offer"}
          </button>
          {listingError.length > 0 && listingError !== "Listing has been closed."&& (
            <p className="error-offer">{listingError}</p>
          )}
        </div>
      </div>
      {
        show && <SaveClosingModal handleClose={handleClose} show={show} saveClosingState={saveClosingState} />
      }
    </div>
  );
};

export default FinanceAndClosing;

const RadioButtonGroup = ({
  title,
  options,
  selectedValue,
  onChange,
  mandatory,
  tooltip,
  onBlur
}) => {
  return (
    <>
      <p className="finance-title w-34 mb-0">
        {title}{" "}
        {tooltip && (
          <div
            className="cursor-pointer d-inline-block mb-0 info-tooltip-offer mx-2"
            data-toggle="tooltip"
            data-placement="top"
            title={`Select "No" only if you have a written mortgage commitment from your lender. If you select "No" and are unable to secure financing by the closing date, your Earnest Money deposit may not be refunded.`}
          >
            i
          </div>
        )}
        {mandatory && <span className="mandatory">*</span>}{" "}
      </p>
      <div  onBlur={onBlur} tabIndex={-1}>
        {options.map(({ label, value, id}) => (
          <div className="form-check form-check-inline" key={value}>
            <input
              className="form-check-input"
              type="radio"
              name={title.toLowerCase().replace(" ", "")}
              id={id}
              value={value}
              checked={selectedValue === value}
              onChange={() => onChange(value)}
              // onBlur={()=>onBlur(value)}
            />
            <label className="form-check-label mt-1" htmlFor={id}>
              {label}
            </label>
          </div>
        ))}
        {/* {selectedValue?.length === 0 && (
        <p className="error-offer">{title}</p>
      )} */}
      </div>
    </>
  );
};
